var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.message)?_c('div',{staticClass:"growl"},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }